<template>
    <div class="simple-form">
        <el-form :model="bizArea" ref="ruleForm" class="demo-ruleForm">
            <div class="form-group">
                <div class="form-label">
                    <label class="required">名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name" :rules="{validator: validateItem, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="text" v-model="bizArea.name"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">区域编码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="code" :rules="{validator: validateItem, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="text" v-model="bizArea.code"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>区域描述</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="desc">
                        <el-input class="width-1-5x" type="textarea" v-model="bizArea.desc" :rows="3" :maxlength="120"></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import bizAreaApi from '../../api/bizArea'

    export default{
        name: 'swb-retailer-biz-area-save',
        desc: '经营区域保存',
        props: {
            areaId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                bizArea: {}
            }
        },
        created: function () {
            //
            if(!Utils.isNoB(this.areaId)) {
                this.getBizAreaDetail();
            }
        },
        methods: {
            validateItem: function (rule, value, callback) {
                let field = rule.field;
                if(field == 'name') {
                    if(Utils.isNoB(value)) {
                        callback(new Error('不能为空!'));
                    } else if(value.length > 15) {
                        callback(new Error('不能大于15个字符!'));
                    } else {
                        callback();
                    }
                } else if(field == 'code') {
                    if(Utils.isNoB(value)) {
                        callback(new Error('不能为空!'));
                    } else if(value.length > 15) {
                        callback(new Error('不能大于15个字符!'));
                    } else {
                        callback();
                    }
                }
            },
            getBizAreaDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.areaId;
                //
                let msgBoxDlg = MsgBox.loading();
                bizAreaApi.getRetailerBizArea(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let bizArea = result.data;
                        self.bizArea = Utils.merge({}, bizArea);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 返回数据
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        //
                        let bizArea = self.bizArea;
                        let resultData = {
                            name: bizArea.name,
                            code: bizArea.code,
                            desc: bizArea.desc
                        };
                        if(!Utils.isNoB(self.areaId)) {
                            resultData.id = self.areaId;
                        }
                        //
                        result.type = 'info';
                        result.data = resultData;
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizArea/RetailerBizAreaSave.vue